class OhsModulePermissions {
  view_template: boolean;

  create_template: boolean;

  edit_template: boolean;

  archive_template: boolean;

  delete_template: boolean;

  copy_template: boolean;

  edit_master_template: boolean;

  add_sysfield: boolean;

  create_column_control: boolean;

  view_master_record: boolean;

  create_master_record: boolean;

  edit_master_record: boolean;

  archive_master_record: boolean;

  delete_master_record: boolean;

  move_master_record: boolean;

  allocate: boolean;

  allocate_master: boolean;

  view_submaster_record: boolean;

  create_submaster_record: boolean;

  edit_submaster_record: boolean;

  archive_submaster_record: boolean;

  delete_submaster_record: boolean;

  signoff: boolean;

  assign_task: boolean;

  signoff_history: boolean;

  constructor(flag: boolean) {
    this.view_template = flag;
    this.create_template = flag;
    this.edit_template = flag;
    this.archive_template = flag;
    this.delete_template = flag;
    this.copy_template = flag;
    this.edit_master_template = flag;
    this.add_sysfield = flag;
    this.create_column_control = flag;
    this.view_master_record = flag;
    this.create_master_record = flag;
    this.edit_master_record = flag;
    this.archive_master_record = flag;
    this.delete_master_record = flag;
    this.move_master_record = flag;
    this.allocate = flag;
    this.allocate_master = flag;
    this.view_submaster_record = flag;
    this.create_submaster_record = flag;
    this.edit_submaster_record = flag;
    this.archive_submaster_record = flag;
    this.delete_submaster_record = flag;
    this.signoff = flag;
    this.assign_task = flag;
    this.signoff_history = flag;
  }
}

export default OhsModulePermissions;
